import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@youngcapital/component-library';
import { Trans } from 'react-i18next';

import { AppContext } from '../../AppContext';
import Blokkendoos from '../../services/blokkendoos';

const VacancyCard = ({ t, signupFor }) => {
  const { siteAbbr } = useContext(AppContext);

  const blokkendoos = new Blokkendoos();
  const croReplacements = ['YC', 'YC_DE'].find(elem => elem === siteAbbr);
  const showVacancyCard = signupFor;

  return (
    <>
      {showVacancyCard && croReplacements && (
        <Card>
          <h3>{t('fieldset_vacancy_card.title')}</h3>
          <p>
            <Trans i18nKey='fieldset_vacancy_card.text'>
              contentPlaceholder
            </Trans>
            <a href={blokkendoos.getMetaContent('job_opening_path')}>
              {blokkendoos.getMetaContent('job_opening_title')}
            </a>
          </p>
        </Card>
      )}
    </>
  );
};

VacancyCard.propTypes = {
  t: PropTypes.func.isRequired,
  signupFor: PropTypes.string.isRequired
};

export default VacancyCard;
